import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Divider,
  CircularProgress,
  Link,
  Breadcrumbs,
  Button,
} from "@mui/material";

import "../CSS/Layout.css";
import "../CSS/NOFODetail.css";

import { showLocalNum } from "../utils/utils.js";
import { backendCall } from "../utils/Network";
import HomeFrame from "../Components/HomeFrame";
import { GlobalContext } from "../utils/GlobalContext";
import Footer from "../Components/Footer";

export default function NOFODetail() {
  const { isMobile, setGlobalMessage } = useContext(GlobalContext);

  let { nofoid } = useParams();
  let redirectPath = useNavigate();

  const [nofoDetail, setNofoDetail] = useState();
  const [programDetail, setProgramDetail] = useState();
  const [projectList, setProjectList] = useState([]);

  useEffect(() => {
    if (!nofoDetail) {
      backendCall.get("/nofo/" + nofoid).then(function (response) {
        if (response.data.nofo_id == nofoid) {
          setNofoDetail(response.data);
        } else {
          console.log("Invalid nofo detail", response.data);
        }
      });
    }
    if (!programDetail) {
      backendCall
        .get("/program_by_nofo_id/" + nofoid)
        .then(function (response) {
          if (Array.isArray(response.data) && response.data.length > 0) {
            setProgramDetail(response.data[0]);
          } else {
            // setGlobalMessage({severity:'error', content: "Cannot get program data"});
            setProgramDetail({});
            console.log("Invalid nofo program", response.data);
          }
        });
    }
  }, []);

  useEffect(() => {
    const getProjectList = async () => {
      const response = await backendCall.get(
        "/get_project_by_nofo_id_cross_check_program/" + nofoid
      );
      console.log(response.data);
      response.data.length === []
        ? setProjectList([])
        : setProjectList(response.data.slice(0, 5));
    };
    getProjectList();
  }, []);

  // console.log(nofoDetail);
  if (!nofoDetail || !programDetail) {
    return (
      <>
        <HomeFrame currentPageName="NOFO Details" />
        <Box className="display-center">
          <CircularProgress color="primary" sx={{ margin: "auto" }} />
        </Box>
      </>
    );
  }

  var closeDates = [];
  for (var dateInfo of nofoDetail.nofoClosedDate) {
    closeDates.push(dateInfo.closed_date);
  }

  var projectFunding = "";
  if (nofoDetail.program_funding) {
    projectFunding = `Program Funding: $${showLocalNum(
      nofoDetail.program_funding
    )}`;
  }

  var awardSizeInfo = "";
  if (nofoDetail.award_size_min && nofoDetail.award_size_max) {
    awardSizeInfo = `Award Size: $${showLocalNum(
      nofoDetail.award_size_min
    )} to $${showLocalNum(nofoDetail.award_size_max)}`;
  } else if (nofoDetail.award_size_min) {
    awardSizeInfo = `Award Size: $${showLocalNum(nofoDetail.award_size_min)}`;
  } else if (nofoDetail.award_size_max) {
    awardSizeInfo = `Award Size: $${showLocalNum(nofoDetail.award_size_max)}`;
  }

  var projectSizeInfo = "";
  if (nofoDetail.project_size_min && nofoDetail.project_size_max) {
    projectSizeInfo = `Project Size: $${showLocalNum(
      nofoDetail.project_size_min
    )} to $${showLocalNum(nofoDetail.project_size_max)}`;
  } else if (nofoDetail.project_size_min) {
    projectSizeInfo = `Project Size: $${showLocalNum(
      nofoDetail.project_size_min
    )}`;
  } else if (nofoDetail.project_size_max) {
    projectSizeInfo = `Project Size: $${showLocalNum(
      nofoDetail.project_size_max
    )}`;
  }

  var rangeInfo = "";
  if (nofoDetail.match_pct_min && nofoDetail.match_pct_max) {
    rangeInfo = `Range: ${showLocalNum(
      nofoDetail.match_pct_min
    )}% to ${showLocalNum(nofoDetail.match_pct_max)}%`;
  } else if (nofoDetail.match_pct_min) {
    rangeInfo = `Range: ≥ ${showLocalNum(nofoDetail.match_pct_min)}%`;
  } else if (nofoDetail.match_pct_max) {
    rangeInfo = `Range: ≤ ${showLocalNum(nofoDetail.match_pct_max)}%`;
  }

  return (
    <>
      <HomeFrame currentPageName="NOFO Details" />
      <Box className="content-body">
        <Breadcrumbs>
          <Link underline="hover" color="black" fontWeight="bold" href="/">
            Home
          </Link>
          <Link underline="hover" color="black" fontWeight="bold" href="/nofo">
            Funding Opportunities
          </Link>
          <Typography color="gray">{nofoDetail.title}</Typography>
        </Breadcrumbs>
        <Typography variant="h3" m="40px 0px 40px 0px">
          {nofoDetail.title}
        </Typography>
        <Box className="summary-grid">
          <Box sx={{ gridArea: "agency" }} className="summary-grid-first-line">
            <Typography color="primary">Agency:</Typography>
            <Typography>
              {nofoDetail.agency.name ? nofoDetail.agency.name : "N/A"}
            </Typography>
          </Box>
          <Box sx={{ gridArea: "category" }}>
            <Typography color="primary">Category:</Typography>
            <Typography>
              {nofoDetail.nofoCategory.name
                ? nofoDetail.nofoCategory.name
                : "N/A"}
            </Typography>
          </Box>
          <Box sx={{ gridArea: "number" }}>
            <Typography color="primary">NOFO Number:</Typography>
            <Typography>
              {nofoDetail.nofo_number ? nofoDetail.nofo_number : "N/A"}
            </Typography>
          </Box>
          <Box sx={{ gridArea: "doc" }}>
            <Typography color="primary">Doc Number:</Typography>
            <Typography>
              {nofoDetail.doc_number ? nofoDetail.doc_number : "N/A"}
            </Typography>
          </Box>
          <Box sx={{ gridArea: "fhwa" }}>
            <Typography color="primary">FHWA Involved:</Typography>
            <Typography>
              {nofoDetail.fhwa_involved ? nofoDetail.fhwa_involved : "N/A"}
            </Typography>
          </Box>
          <Box sx={{ gridArea: "posted" }}>
            <Typography color="primary">Post Date:</Typography>
            <Typography>
              {nofoDetail.posted_date ? nofoDetail.posted_date : "N/A"}
            </Typography>
          </Box>
          <Box sx={{ gridArea: "closed" }}>
            <Typography color="primary">Close Date:</Typography>
            <Typography>
              {closeDates ? closeDates.join(", ") : "N/A"}
            </Typography>
          </Box>
        </Box>

        <Box className="contents">
          <Box>
            {nofoDetail.summary &&
              nofoDetail.summary
                .trim()
                .split("\n")
                .map((i, key) => <Typography key={key}>{i}</Typography>)}
            <Typography variant="h3" color="primary">
              Program
            </Typography>
            {Object.keys(programDetail).length === 0 && (
              <Typography>N/A</Typography>
            )}
            <Typography>{programDetail.name}</Typography>
            <Typography color="gray">
              {programDetail.alternative_name}
            </Typography>
            <Link
              href={programDetail.web_link}
              color="secondary"
              target="_blank"
            >
              {programDetail.web_link}
            </Link>
            {programDetail.description && (
              <Typography>{programDetail.description}</Typography>
            )}
            <Typography variant="h3" color="primary">
              Financial
            </Typography>
            {(awardSizeInfo || projectSizeInfo || projectFunding) && (
              <Typography fontWeight={"bold"}>Funding</Typography>
            )}
            <Box sx={{ ml: 2 }}>
              <Typography>{projectFunding}</Typography>
              <Typography>{awardSizeInfo}</Typography>
              <Typography>{projectSizeInfo}</Typography>
            </Box>
            <Typography fontWeight={"bold"}>Match</Typography>
            <Box sx={{ ml: 2 }}>
              <Typography>Required: {nofoDetail.match_required}</Typography>
              <Typography>{rangeInfo}</Typography>
              <Typography>Type: {nofoDetail.match_type}</Typography>
            </Box>
            <Typography variant="h3" color="primary">
              Eligible Applicants
            </Typography>
            {nofoDetail.eligibility_additional_info}
            {/* {nofoDetail.organizationTypes.map((org) => (
              <Typography key={org.name}>{org.name}</Typography>
            ))} */}
            <Typography variant="h3" color="primary">
              Eligible Projects
            </Typography>
            {nofoDetail.eligible_projects &&
              nofoDetail.eligible_projects
                .trim()
                .split("\n")
                .map((i, key) => <Typography key={key}>{i}</Typography>)}
          </Box>
          {!isMobile && (
            <Box sx={{ paddingRight: "25px" }}>
              <Divider orientation="vertical" variant="middle" />
            </Box>
          )}

          {isMobile && (
            <Box sx={{ paddingTop: "40px" }}>
              <Divider />
            </Box>
          )}

          <Box>
            <Typography variant="h3" color="primary" mt={0}>
              Contact Info
            </Typography>
            {nofoDetail.contact_info &&
              nofoDetail.contact_info
                .trim()
                .split("\n")
                .map((i, key) => <Typography key={key}>{i}</Typography>)}
            <Typography variant="h3" color="primary">
              Links and Files
            </Typography>
            <Box className="flex-column-left" sx={{ gap: "15px" }}>
              {nofoDetail.nofoFileList.map((file) => (
                <Link
                  href={file.file_url}
                  color="secondary"
                  target="_blank"
                  key={file.file_name}
                >
                  {file.file_name}
                </Link>
              ))}
            </Box>
            {projectList.length !== 0 && (
              <>
                <Typography variant="h3" color="primary">
                  Successful Applications
                </Typography>
                <Box className="flex-column-left" sx={{ gap: "15px" }}>
                  {projectList?.map((project) => (
                    <Link
                      href={project.projectFileList[0].file_url}
                      color="secondary"
                      target="_blank"
                      key={project.name}
                    >
                      {project.name}
                    </Link>
                  ))}
                </Box>
                <Button
                  sx={{ mt: 2 }}
                  variant="contained"
                  onClick={() => redirectPath("/successfulawards")}
                >
                  For more project, please click here
                </Button>
              </>
            )}
          </Box>
        </Box>
      </Box>
      <Footer />
    </>
  );
}
